import { render } from "./ChooseConsignment.vue?vue&type=template&id=2332388b&scoped=true"
import script from "./ChooseConsignment.vue?vue&type=script&lang=js"
export * from "./ChooseConsignment.vue?vue&type=script&lang=js"

import "./ChooseConsignment.vue?vue&type=style&index=0&id=2332388b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2332388b"]])

export default __exports__